import { useCallback, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export const useQuantity = (
  defaultValue: number = 1,
): [number, (value: number) => void] => {
  const [searchParams, setSearchParams] = useSearchParams();
  const quantity = searchParams.get("quantity");

  const setQuantity = useCallback(
    (value: number) => {
      setSearchParams((prev) => {
        const next = new URLSearchParams(prev);
        next.set("quantity", String(value));
        return next;
      });
    },
    [setSearchParams],
  );

  useEffect(() => {
    if (quantity != null) return;

    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.set("quantity", String(defaultValue));
        return next;
      },
      { replace: true },
    );
  }, [defaultValue, quantity, setQuantity, setSearchParams]);

  return [
    quantity != null ? parseInt(quantity, 10) : defaultValue,
    setQuantity,
  ];
};
